import {
  apiURL
} from '../../config/app';

const getPatients = async ({ authToken, pageSection = 'all', searchName, lastEvaluatedKey }) => {
  const response = await fetch(`${apiURL}/patients?pageSection=${pageSection}${searchName ? `&searchName=${searchName}` : ''}${lastEvaluatedKey ? `&lastEvaluatedKey=${lastEvaluatedKey}` : ''}`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  })
  if (!response.ok)
    throw await response.json()

  return response.json();
};

const getPatientsShort = async ({ authToken, query }) => {
  const response = await fetch(`${apiURL}/patients/short?searchName=${query}`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  })
  if (!response.ok)
    throw await response.json()

  return response.json();
};

const savePatient = async ({ payload, authToken }) => {
  const response = await fetch(`${apiURL}/patients`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    body: JSON.stringify(payload)
  })
  if (!response.ok)
    throw await response.json()

  return response.json();
};

const updatePatient = async ({ payload, authToken }) => {
  const response = await fetch(`${apiURL}/patients/${payload.id}`, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    body: JSON.stringify(payload)
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

const deletePatient = async ({ payload, authToken }) => {
  const response = await fetch(`${apiURL}/patients/${payload.id}`, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

const getPatientById = async ({ authToken, patientId }) => {
  const response = await fetch(`${apiURL}/patients/${patientId}`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

const uploadImages = async ({ payload, authToken }) => {
  const response = await fetch(`${apiURL}/patients/images`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    body: JSON.stringify(payload)
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

const deleteImages = async ({ authToken, payload }) => {
  const response = await fetch(`${apiURL}/patients/${payload.patientId}/images/${payload.imageId}`, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

const getPatientsHistory = async ({ authToken, payload }) => {
  const response = await fetch(`${apiURL}/patients/${payload.patientId}/history`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

const addNewPaid = async ({ payload, authToken }) => {
  const response = await fetch(`${apiURL}/history/${payload.id}/paid`, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    body: JSON.stringify({
      paid: Number(payload.newPayment)
    })
  })
  if (!response.ok)
    throw await response.json()

  return response.json();
};


export default {
  getPatients,
  getPatientsShort,
  savePatient,
  updatePatient,
  deletePatient,
  getPatientById,
  uploadImages,
  deleteImages,
  getPatientsHistory,
  addNewPaid
};



// WEBPACK FOOTER //
// ./api/patients.js